import inputMask from '@/views/directives/input-mask/inputMask'
import Vue from 'vue'

export default {
	install() {
		Vue.directive('input-mask', inputMask)
	},
}
